import { useQuery } from '@tanstack/react-query'
import { getExperienceDetail } from 'tripPlanner/api'
import * as ExperienceDetailKeys from 'tripPlanner/hooks/reactQueryKeys/experienceDetail'

const EXPERIENCE_DETAIL_STALE_TIME = 10 * 60 * 1000

interface UseExperienceDetailOptions {
  offerId: string | undefined
  currencyCode: string
  enabled?: boolean
}

export default function useExperienceDetail({
  offerId,
  currencyCode,
  enabled = true,
}: UseExperienceDetailOptions) {
  const queryResult = useQuery({
    queryKey: ExperienceDetailKeys.detail(offerId ?? '', currencyCode),
    queryFn: () => getExperienceDetail(offerId!, currencyCode),
    enabled: enabled && !!offerId,
    staleTime: EXPERIENCE_DETAIL_STALE_TIME,
  })

  return {
    experienceDetail: queryResult.data,
    isLoading: queryResult.isLoading && queryResult.fetchStatus !== 'idle',
    isError: queryResult.isError,
    refetch: queryResult.refetch,
  }
}
